import type { Coupon } from '@entities/product/api/product.contract'
import type { Currency } from '@shared/contracts/enums'

export const COUPON_END_DATE_PAST_MESSAGE = 'A data final deve ser hoje ou posterior.'

export function couponAmountForCurrency(
  coupon: Pick<Coupon, 'amount'>,
  currency: Currency,
): Coupon['amount'] {
  return { amount: coupon.amount.amount, currency }
}

export function couponEndDateError(
  coupon: Pick<Coupon, 'active' | 'endsAt'>,
  today: string,
): string | undefined {
  if (!coupon.active) return undefined

  const endDate = coupon.endsAt.slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(endDate) || endDate === '9999-12-31' || endDate >= today) {
    return undefined
  }

  return COUPON_END_DATE_PAST_MESSAGE
}
